/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyAccessCode
 */
export interface ReadOnlyAccessCode {
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyAccessCode
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyAccessCode
     */
    readonly code?: string;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyAccessCode
     */
    readonly deleted?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyAccessCode
     */
    transportId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyAccessCode
     */
    start?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyAccessCode
     */
    end?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyAccessCode
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyAccessCode
     */
    client: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReadOnlyAccessCode
     */
    monitoredObjects?: Array<number>;
}

export function ReadOnlyAccessCodeFromJSON(json: any): ReadOnlyAccessCode {
    return ReadOnlyAccessCodeFromJSONTyped(json, false);
}

export function ReadOnlyAccessCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyAccessCode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'transportId': !exists(json, 'transport_id') ? undefined : json['transport_id'],
        'start': !exists(json, 'start') ? undefined : (json['start'] === null ? null : new Date(json['start'])),
        'end': !exists(json, 'end') ? undefined : (json['end'] === null ? null : new Date(json['end'])),
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'client': json['client'],
        'monitoredObjects': !exists(json, 'monitored_objects') ? undefined : json['monitored_objects'],
    };
}

export function ReadOnlyAccessCodeToJSON(value?: ReadOnlyAccessCode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'transport_id': value.transportId,
        'start': value.start === undefined ? undefined : (value.start === null ? null : value.start.toISOString()),
        'end': value.end === undefined ? undefined : (value.end === null ? null : value.end.toISOString()),
        'client': value.client,
        'monitored_objects': value.monitoredObjects,
    };
}


